import {
    Injectable
} from '@angular/core';
import { Auth, authState } from '@angular/fire/auth';
import { collection, collectionData, Firestore, query } from '@angular/fire/firestore';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, ActivatedRoute } from '@angular/router';
import {
    ToastController
} from '@ionic/angular';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ClubLobbyGuard  {

    constructor(
        private toastCtrl: ToastController,
        private router: Router,
        public route: ActivatedRoute,
        private firestore: Firestore,
        private fireAuth: Auth,
    ) {}
    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise < boolean | UrlTree > {
        return new Promise(async (resolve, reject) => {
                const clubID = next.paramMap.get('id');
                if (clubID && clubID != "undefined") {
                    const userId = (await firstValueFrom(authState(this.fireAuth)))?.uid;
                    if (!userId) return resolve(this.router.parseUrl('/login'));
                    const collectionReference = collection(this.firestore, `users/${userId}/clubs`);
                    const collectionQuery = query(collectionReference);
                    const userClubs = await firstValueFrom(collectionData(collectionQuery));
                    const clubFound = userClubs.find( club => club.id === clubID) != undefined;
                    if(clubFound) return resolve(true);
                    return resolve(false);
                } else {
                    const url: UrlTree = this.router.parseUrl('/lobby');
                    return resolve(url);
                }
            });
    }
}
